import * as React from "react";
const SvgCalendarIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4H12V2H14V4H17V16H3V4H6V2H8V4ZM5 14H15V6H14V7H12V6H8V7H6V6H5V14Z", fill: "#101F44" }));
export default SvgCalendarIcon;
